module.exports = __webpack_public_path__ + "static/media/phone2.43d35631.svg";